class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/bulk-assign`;
    }
    /**
     * Assigns multiple user roles.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/user-role/{roleId}/bulk-assign
     * Rate Limit Group: Heavy
     * App Permission: RoleManagement
     * User Permission: EditUserRoles
     */
    async post(bulkRoleAssignResource, restRequestConfig) {
        const r = await this.rc.post(this.path(), bulkRoleAssignResource, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
